import { useTranslation } from "react-i18next";
import { formatNumber } from "@/shared/utils";
import ArrowUpRed from "@/assets/icons/arrow-narrow-up.svg?react";
import ArrowDown from "@/assets/icons/daily_checkin.svg?react";
import dayjs from "dayjs";
import {cn} from "@/lib/utils.ts";
import { HistoryPurposes, Transaction } from "@/pages/history/types.ts";

type HistoryProps = Transaction;

const HistoryCard = (props: HistoryProps) => {
  const { t } = useTranslation();

  return (
    <div className="py-2.5 px-3 rounded-lg flex items-center gap-1 justify-between bg-white/08 border-b border-white/08">
      <div className="flex items-center justify-center gap-2">
        <div className="bg-white/08 w-7 h-7 rounded-lg flex items-center justify-center shrink-0">
          {props.type !== -1 ? (
            <ArrowDown className="size-6" />
          ) : (
            <ArrowUpRed className="size-6" />
          )}
        </div>
        <div className="flex flex-col items-start justify-center gap-0.5">
          <p className="text-sm font-semibold leading-4 text-white">
            {props.display_title}
          </p>
          <p className="text-xs leading-130 text-gray-1">
            {props.purpose === HistoryPurposes.EXTERNAL_APP
              ? props.application?.name
              : t(`award_text.${props.purpose}`, { defaultValue: "" })
            }
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-0.5 justify-center items-end shrink-0">
        <span
          className={cn("text-sm font-semibold leading-4 flex-y-center gap-0.5", props.type === -1 ? "text-red" : "text-green")}
        >
          {(props.type === -1 ? "-" : "+") + formatNumber(props.amount)} DON
        </span>
        <p className="text-xs font-normal leading-130 text-gray-400 shrink-0">
          {dayjs(props.created_at).format("DD.MM.YYYY HH:mm")}
        </p>
      </div>
    </div>
  );
};

export default HistoryCard;
